import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { env } from '../../environments/environment';
import { Role } from '../shared/interfaces';

@Injectable({
  providedIn: 'root',
})
export class RoleService {
  constructor(protected http: HttpClient) {}

  public async list() {
    const rolesToHide = ['Vendor', 'Inspector'];
    return (await this.http.get<Role[]>(`${env.APIUrl}/role`).toPromise()).filter(r => !rolesToHide.includes(r.name));
  }

  public get(id: number) {
    return this.http.get<Role>(`${env.APIUrl}/role/${id}`).toPromise();
  }

  public remove(id: number): Promise<Role> {
    return this.http.delete<Role>(`${env.APIUrl}/role/${id}`).toPromise();
    // throw new Error(`It's not possible to perform this action`);
  }

  public edit(id: number, role: Role): Promise<Role> {
    return this.http.put<Role>(`${env.APIUrl}/role/${id}`, role).toPromise();
    // throw new Error(`It's not possible to perform this action`);
  }

  public create(role: Role): Promise<Role> {
    return this.http.post<Role>(`${env.APIUrl}/role`, role).toPromise();
    // throw new Error(`It's not possible to perform this action`);
  }

  public allPermissions() {
    return this.http.get<any>(`${env.APIUrl}/permission`).toPromise();
  }
}
